var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("h1", [_vm._v("Empresa")]),
      _vm._v(" "),
      !_vm.loading
        ? [
            !_vm.error
              ? _c(
                  "div",
                  { staticClass: "container" },
                  [
                    _c("h3", [_vm._v("Datos empresa")]),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Empresa" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        disabled: _vm.disabled,
                                        name: "Empresa"
                                      },
                                      model: {
                                        value: _vm.form.nombre_entidad,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "nombre_entidad",
                                            $$v
                                          )
                                        },
                                        expression: "form.nombre_entidad"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "error" }, [
                                      _vm._v(
                                        _vm._s(_vm.errors.first("Empresa"))
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "CIF" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: { disabled: "", name: "CIF" },
                                      model: {
                                        value: _vm.form.cif,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "cif", $$v)
                                        },
                                        expression: "form.cif"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "error" }, [
                                      _vm._v(_vm._s(_vm.errors.first("CIF")))
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Dirección" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        disabled: _vm.disabled,
                                        name: "Dirección"
                                      },
                                      model: {
                                        value: _vm.form.direccion,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "direccion", $$v)
                                        },
                                        expression: "form.direccion"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "error" }, [
                                      _vm._v(
                                        _vm._s(_vm.errors.first("Dirección"))
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Provincia" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: _vm.disabled },
                                      model: {
                                        value: _vm.form.codigo_provincia_ine,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "codigo_provincia_ine",
                                            $$v
                                          )
                                        },
                                        expression: "form.codigo_provincia_ine"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Website" }
                                  },
                                  [
                                    !_vm.disabled
                                      ? _c("b-form-input", {
                                          model: {
                                            value: _vm.form.website,
                                            callback: function($$v) {
                                              _vm.$set(_vm.form, "website", $$v)
                                            },
                                            expression: "form.website"
                                          }
                                        })
                                      : _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.form.website,
                                              target: "_blank"
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.form.website))]
                                        )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Teléfono" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: { disabled: _vm.disabled },
                                      model: {
                                        value: _vm.form.telefono_principal,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "telefono_principal",
                                            $$v
                                          )
                                        },
                                        expression: "form.telefono_principal"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Email" }
                                  },
                                  [
                                    _c("b-form-input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        disabled: _vm.disabled,
                                        name: "Email"
                                      },
                                      model: {
                                        value: _vm.form.email_principal,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "email_principal",
                                            $$v
                                          )
                                        },
                                        expression: "form.email_principal"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "error" }, [
                                      _vm._v(_vm._s(_vm.errors.first("Email")))
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: {
                                      label: "Ambito presupuesto provincias"
                                    }
                                  },
                                  [
                                    _c("multiselect", {
                                      attrs: {
                                        placeholder: "",
                                        "deselect-label":
                                          "Click o enter para deseleccionar",
                                        "select-label":
                                          "Click o enter para seleccionar",
                                        options: _vm.ambitos_options,
                                        multiple: true,
                                        "close-on-select": false,
                                        label: "nombre_provincia_ine",
                                        "track-by": "zeus_codigo_provincia_ine",
                                        disabled: ""
                                      },
                                      model: {
                                        value: _vm.ambitos,
                                        callback: function($$v) {
                                          _vm.ambitos = $$v
                                        },
                                        expression: "ambitos"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Descripción" }
                                  },
                                  [
                                    _c("trumbowyg", {
                                      staticClass: "form-control",
                                      attrs: {
                                        name: "content",
                                        config: _vm.config
                                      },
                                      model: {
                                        value: _vm.form.descripcion_comercial,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "descripcion_comercial",
                                            $$v
                                          )
                                        },
                                        expression: "form.descripcion_comercial"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("h3", [_vm._v("Archivos")]),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: { label: "Logo (.png / .jpeg)" }
                                  },
                                  [
                                    _vm.form.logo_empresa
                                      ? _c("img", {
                                          staticStyle: { "max-width": "50%" },
                                          attrs: {
                                            src: _vm.parseMedia(
                                              _vm.form.logo_empresa
                                            ),
                                            alt: ""
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.logo_empresa && !_vm.disabled
                                      ? _c(
                                          "b-button",
                                          {
                                            attrs: { variant: "danger" },
                                            on: { click: _vm.deleteLogo }
                                          },
                                          [_vm._v("Borrar logo")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    !_vm.disabled
                                      ? _c("input", {
                                          ref: "logo",
                                          attrs: {
                                            type: "file",
                                            id: "logo",
                                            name: "logo",
                                            accept: "image/png, image/jpeg"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          [
                            _c(
                              "b-form",
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    staticStyle: { "font-size": "1rem" },
                                    attrs: {
                                      label: "Documento presentación (.pdf)"
                                    }
                                  },
                                  [
                                    _vm.form.documentacion_comercial
                                      ? _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.parseMedia(
                                                _vm.form.documentacion_comercial
                                              ),
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                " +
                                                _vm._s(
                                                  _vm.form.documentacion_comercial.split(
                                                    "/"
                                                  )[
                                                    _vm.form.documentacion_comercial.split(
                                                      "/"
                                                    ).length - 1
                                                  ]
                                                ) +
                                                "\n                            "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.form.documentacion_comercial &&
                                    !_vm.disabled
                                      ? _c(
                                          "b-button",
                                          {
                                            attrs: { variant: "danger" },
                                            on: { click: _vm.deleteDocumento }
                                          },
                                          [_vm._v("Borrar documento")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    !_vm.disabled
                                      ? _c("input", {
                                          ref: "file",
                                          attrs: {
                                            type: "file",
                                            id: "doc",
                                            name: "doc",
                                            accept: "application/pdf",
                                            disabled: _vm.disabled
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.error && !_vm.disabled
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "end" } },
                  [
                    _c("b-button", { on: { click: _vm.getData } }, [
                      _vm._v("Cancelar")
                    ]),
                    _vm._v(" "),
                    _c("b-button", { on: { click: _vm.saveData } }, [
                      _vm._v("Guardar")
                    ])
                  ],
                  1
                )
              : _c("div", { staticClass: "container" }, [
                  _c("h3", { staticStyle: { color: "red" } }, [
                    _vm._v(_vm._s(_vm.error))
                  ])
                ])
          ]
        : [_vm._v("\n        Loading...\n    ")]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Form/Form.vue?vue&type=template&id=274f32b8&
// module id = null
// module chunks = 